import { theme } from '@garnish/constants';

export const TOGGLE_SIZE = 64;
export const TOGGLE_SIZE_NEW = 56;
export const TOGGLE_ICON_SIZE = 32;
export const TOGGLE_ICON_SIZE_NEW = 24;

export const DIALOG_PADDING = theme.spacing['2'];

const DEFAULT_ANIMATION_DURATION = 400;

export const DIALOG_ANIMATIONS = {
  ENTRY_SPRING_MASS: 0.7,
  EXIT_DURATION: DEFAULT_ANIMATION_DURATION,
  EXIT_DELAY: DEFAULT_ANIMATION_DURATION,

  CONTENT_ENTRY_DELAY: DEFAULT_ANIMATION_DURATION + 200,
  CONTENT_ENTRY_DURATION: DEFAULT_ANIMATION_DURATION - 100,
  CONTENT_EXIT_DURATION: DEFAULT_ANIMATION_DURATION,
};

export const TOGGLE_ANIMATIONS = {
  SHOW_ENTRY_DURATION: 0.7,
  SHOW_EXIT_DELAY: DEFAULT_ANIMATION_DURATION + 100,
  SHOW_EXIT_DURATION: DEFAULT_ANIMATION_DURATION + 100,

  HIDE_ENTER_DELAY: DEFAULT_ANIMATION_DURATION + 200,
  HIDE_ENTER_DURATION: DEFAULT_ANIMATION_DURATION,
  HIDE_EXIT_DURATION: DEFAULT_ANIMATION_DURATION,
};
